export default "__VITE_ASSET__B_XD0816__"